import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const GIFT_KEY = 'app::main::gift';
export type GiftState = {
    accountType: number;
    currencyGiftEnable: boolean;
    lobbyGiftEnable: boolean;
    giftList: Array<Gift>;
    confirmedGift: ConfirmedGift;
};
export type Gift = {
    ID: number;
    Name?: string;
    DisplayName?: string;
    Interval?: number;
    Order: number;
    Amount: number;
};

export type ConfirmedGift = {
    UUID: string;
    HostID: number;
    GiftID: number;
};

const initialGiftState = {} as GiftState;
const updateData = (
    state: GiftState,
    action: PayloadAction<{
        accountType: number;
        currencyGiftEnable: boolean;
        lobbyGiftEnable: boolean;
        giftList: Array<Gift>;
    }>
) => {
    state.accountType = action.payload.accountType;
    state.currencyGiftEnable = action.payload.currencyGiftEnable;
    state.lobbyGiftEnable = action.payload.lobbyGiftEnable;
    state.giftList = action.payload.giftList.sort((a, b) => a.Order - b.Order);
};
const updateConfirmedGift = (
    state: GiftState,
    action: PayloadAction<ConfirmedGift>
) => {
    state.confirmedGift = action.payload;
};

const giftSlice = createSlice({
    name: GIFT_KEY,
    initialState: initialGiftState,
    reducers: {
        updateData,
        updateConfirmedGift,
    },
});
export const giftSliceReducer = giftSlice.reducer;
export const giftSliceActions = giftSlice.actions;
